import {ApexOptions} from 'apexcharts';
import React, {lazy, Suspense, useContext, useEffect, useState} from 'react';
import ReactApexChart from 'react-apexcharts';
import {Context} from '../../../../Helpers/Auth';
import {useTranslation} from 'react-i18next';
import Spinner from '../../../Spinner';
import {getLeadsProspects} from '../../../../pages/requests';

const ChartOne = () => {
    const {theme} = useContext(Context);
    const {t} = useTranslation();

    // Loadings
    const [loading, setLoading] = useState(true);

    let lang;
    switch (localStorage.getItem('i18nextLng')) {
        case 'pt':
            lang = 'POR';
            break;
        case 'fr':
            lang = 'FRA';
            break;
        case 'en':
            lang = 'ENG';
            break;
        case 'es':
            lang = 'ES'; 
            break;
    }
    const [state, setState] = useState({
        series: [
            {
                name: 'Product One',
                type: 'area',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
            {
                name: 'Product Two',
                type: 'area',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
            {
                name: t('criados'),
                type: 'bar',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
            {
                name: t('leadConvertidos'),
                type: 'bar',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
        ],
    });

    useEffect(() => {
        setLoading(false);
        var promises = [];
        promises.push(
            getLeadsProspects(lang).then(res => {
                if (res.data.success) {
                    const updatedSeries = state.series.map((item, index) => {
                        const leadData = res.data.leads[index];
                        return {
                            ...item,
                            name: leadData.tipo,
                            data: leadData.valores,
                        };
                    });

                    setState({
                        series: updatedSeries,
                    });
                }
            }),
        );

        Promise.all(promises).finally(() => {
            setLoading(false);
        });
    }, []);
console.log(state, "state");
    const options = {
        plotOptions: {
            bar: {
                columnWidth: '50%',
            },
        },

        legend: {
            show: false,
            position: 'top',
            horizontalAlign: 'left',
        },
        colors: ['#0210EA', '#8100EB', '#9DA1EB', '#5EA1EB'],
        fill: {opacity: [0, 0, 0.5, 0.5]},
        chart: {
            fontFamily: 'Satoshi, sans-serif',
            height: 335,
            type: 'area',
            dropShadow: {
                enabled: true,
                color: '#623CEA14',
                top: 10,
                blur: 4,
                left: 0,
                opacity: 0.1,
            },
            toolbar: {
                show: false,
            },
        },
        responsive: [
            {
                breakpoint: 1024,
                options: {
                    chart: {
                        height: 300,
                    },
                },
            },
            {
                breakpoint: 1366,
                options: {
                    chart: {
                        height: 350,
                    },
                },
            },
        ],
        stroke: {
            width: [2, 2],
            curve: 'straight',
        },
        grid: {
            show: true,
            borderColor: '#00f',
            strokeDashArray: 5,
            position: 'back',
            xaxis: {
                lines: {
                    show: true,
                    colors: '#fff',
                },
            },
            yaxis: {
                lines: {
                    show: true,
                },
            },
        },
        dataLabels: {
            enabled: false,
        },
        markers: {
            size: 4,
            colors: '#fff',
            strokeColors: ['#0210EA', '#8100EB', '#9DA1EB', '#5EA1EB'],
            strokeWidth: 3,
            strokeOpacity: 0.9,
            strokeDashArray: 0,
            fillOpacity: 1,
            discrete: [],
            fillColors: ['#9DA1EB', '#5EA1EB'],
            hover: {
                size: undefined,
                sizeOffset: 5,
            },
        },
        xaxis: {
            type: 'category',
            categories: [t('jan'), t('fev'), t('mar'), t('abr'), t('maio'), t('jun'), t('jul'), t('ago'), t('set'), t('out'), t('nov'), t('dez')],
            labels: {
                style: {
                    colors: theme == 'dark' ? '#94b7ab' : '#000',
                },
            },
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
        },
        yaxis: {
            title: {
                style: {
                    fontSize: '0px',
                },
            },
            min: 0,
            max: Math.max(5, ...state.series.map(e => Math.max(...e.data))),
            labels: {
                style: {
                    colors: theme == 'dark' ? '#94b7ab' : '#000',
                },
            },
        },
    };
    return (
        <div className="col-span-12 rounded-[8px] shadow-md  border-stroke bg-white dark:bg-gray-800 px-5 pt-7.5 pb-5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 xl:col-span-8">
            <div className="flex flex-wrap items-start justify-between gap-3 sm:flex-nowrap">
                <div className="flex w-full mt-8 flex-wrap gap-3 sm:gap-5 justify-between">
                    <div>
                        <p className="font-semibold  dark:text-white text-black ">{t('leadsProspects')} </p>
                    </div>
                    <div className="flex flex-col ">
                        <div className="flex flex-row">
                            <div className="flex mb-2 mr-6 min-w-47.5">
                                <div className="flex border-4  justify-center mr-2 items-center border-[#0210EA] bg-white w-5 h-5  rounded-full transition-all duration-300 transform group-hover:rotate-12">
                                    <span className="w-12 h-12 p-1 text-blue-800 dark:text-gray-800 transform transition-transform duration-500 ease-in-out" />
                                </div>
                                <div className="w-full">
                                    <p className="font-semibold text-[#0210EA] dark:text-[#2c3af9] ">{state.series[0]?.name}</p>
                                </div>
                            </div>
                            <div className="flex mr-2 min-w-47.5">
                                <div className="flex border-4  justify-center mr-2 items-center border-[#8100EB] bg-white w-5 h-5  rounded-full transition-all duration-300 transform group-hover:rotate-12">
                                    <span className="w-12 h-12 p-1 text-blue-800 dark:text-gray-800 transform transition-transform duration-500 ease-in-out" />
                                </div>
                                <div className="w-full">
                                    <p className="font-semibold text-[#8100EB] dark:text-[#992af9]">{state.series[0]?.name}</p>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-row">
                            <div className="flex mr-6 min-w-47.5">
                                <div className="flex border-4  justify-center mr-2 items-center border-[#9DA1EB] bg-white w-5 h-5  rounded-full transition-all duration-300 transform group-hover:rotate-12">
                                    <span className="w-12 h-12 p-1 text-blue-800 dark:text-gray-800 transform transition-transform duration-500 ease-in-out" />
                                </div>
                                <div className="w-full">
                                    <p className="font-semibold text-[#9DA1EB] ">{state.series[2]?.name}</p>
                                </div>
                            </div>
                            <div className="flex mr-2 min-w-47.5">
                                <div className="flex border-4  justify-center mr-2 items-center border-[#5EA1EB] bg-white w-5 h-5  rounded-full transition-all duration-300 transform group-hover:rotate-12">
                                    <span className="w-12 h-12 p-1 text-blue-800 dark:text-gray-800 transform transition-transform duration-500 ease-in-out" />
                                </div>
                                <div className="w-full">
                                    <p className="font-semibold text-[#5EA1EB] ">{state.series[3]?.name}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div id="chartOne" className="-ml-5">
                    <ReactApexChart options={options} series={state.series} type={state.series.type} height={320} />
                </div>
            </div>
        </div>
    );
};

export default ChartOne;
